import { IDateBoxOptions } from 'devextreme-react/date-box';
import { iCheckBoxDisplayOptions } from 'fulogics-ui-web';
import { LogisticUnitSimpleTextProps } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { iFormDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Form/Form';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof';
import { AllowedStacksHeaderProps } from '../../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeader';
import { OrderForwardStepData } from '../OrderForwardStepData';
import { OrderForwardStepPayloadItemData } from './OrderForwardStepForm';

export const orderForwardStepFormValidationGroup = 'orderForwardStepForm';

export const OrderForwardStepFormHeaderId = 'OrderForwardStepForm.Header';
const OrderForwardStepFormHeaderOptions: LogisticUnitSimpleTextProps & {
    id: string;
} = {
    id: OrderForwardStepFormHeaderId,
    //
    hideContactButton: true,
};
propsStore.insert(OrderForwardStepFormHeaderOptions);

export const orderStepsForwardRemoveStepButtonId = 'OrderForwardStepForm.removeStepButton';
const orderStepsForwardRemoveStepButtonOptions: iButtonDisplayOptions = {
    id: orderStepsForwardRemoveStepButtonId,
    //
    width: '200px',
    type: 'danger',
    stylingMode: 'text',
    //
    text: 't~OrderForwardStepForm:removeStepButton',
};
propsStore.insert(orderStepsForwardRemoveStepButtonOptions);

export const OrderForwardStepFormFormId = 'OrderForwardStepForm.form';
const OrderForwardStepFormFormOptions: iFormDisplayOptions = {
    id: OrderForwardStepFormFormId,
    labelLocation: 'left',
    validationGroup: orderForwardStepFormValidationGroup,
    showValidationSummary: true,
    items: [
        {
            itemType: 'simple',
            label: {
                text: 't~OrderForwardStepForm:location',
            },

            dataField: nameof<OrderForwardStepData>((c) => c.location!.logisticUnit),
            editorType: 'dxSelectBox',

            //
            editorOptions: {
                displayExpr: 'name',
                dataSource: 'ds~destinationLocationsDataSource',
                //itemTemplate: "LogisticUnitSimpleTextItem"
            },
            validationRules: [
                {
                    type: 'required',
                    message: 't~OrderForwardStepForm:validation.logisticUnit.required',
                },
            ],
            isRequired: true,
        },
        // TODO: uzupełnić za pomocą VStora :
        /*
            disabledDates={props.disabledDate}
        */
        {
            dataField: nameof<OrderForwardStepData>((c) => c.plannedStartDate),
            editorType: 'dxDateBox',
            //template: 'DateBoxItem', <- nie pamiętam, czemu był template, bez template działa
            itemType: 'simple',
            label: {
                text: 't~OrderForwardStepForm:plannedStartDate',
            },
            editorOptions: {
                type: 'datetime',
                defaultValue: 'v~minPlannedStartDate',
                acceptCustomValue: false,
                openOnFieldClick: true,
                max: 'v~maxPlannedStartDate',
                min: 'v~minPlannedStartDate',
                dateOutOfRangeMessage: 't~OrderForwardStepForm:dateOutOfRange',
            } as IDateBoxOptions,
            isRequired: true,
            validationRules: [
                {
                    type: 'required',
                    message: 't~OrderForwardStepForm:validation.plannedStartDate.required',
                },
                {
                    type: 'range',
                    message: 't~OrderForwardStepForm:validation.plannedStartDate.outOfRange',
                    max: 'v~maxPlannedStartDate' as any,
                    min: 'v~minPlannedStartDate' as any,
                },
            ],
        },
    ],
};
propsStore.insert(OrderForwardStepFormFormOptions);

export const OrderForwardStepFormGridId = 'OrderForwardStepForm.grid';
const OrderForwardStepFormGridOptions: iDataGridDisplayOptions = {
    id: OrderForwardStepFormGridId,
    columnAutoWidth: true,
    showBorders: false,
    width: '100%',
    height: '100%',
    //
    columns: [
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.id),
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexColumn',
        },
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.sku),
            caption: 't~Payload:column.sku',
            width: '30%',
        },
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.name),
            caption: 't~Payload:column.productName',
            width: '70%',
        },
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.productsQuantity),
            caption: 't~Payload:column.productsQuantity',
            width: '100px',
        },
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.requestedAmount),
            caption: 't~Payload:column.requestedAmount',
            width: '160px',
        },
        {
            dataField: nameof<OrderForwardStepPayloadItemData>((c) => c.carriersQuantity),
            headerCellTemplate: 'AllowedStacksHeader',
            cellTemplate: 'PayloadCarrierCountSimpleText',
            width: '120px',
        },
    ],
};
propsStore.insert(OrderForwardStepFormGridOptions);

export const orderStepsForwardAddAllowedStacksHeaderId =
    'OrderForwardStepForm.grid.column.carriersQuantity';
const orderStepsForwardAddAllowedStacksHeaderOptions: AllowedStacksHeaderProps = {
    id: orderStepsForwardAddAllowedStacksHeaderId,
    title: 't~Payload:column.carriersQuantity',
};
propsStore.insert(orderStepsForwardAddAllowedStacksHeaderOptions);

export const orderStepsForwardAddPayloadButtonId = 'OrderForwardStepForm.addPayloadButton';
const orderStepsForwardAddPayloadButtonOptions: iButtonDisplayOptions = {
    id: orderStepsForwardAddPayloadButtonId,
    //
    icon: 'plus',
    type: 'success',
    width: '250px',
    //
    text: 't~OrderForwardStepForm:addPayloadButton',
    validationGroup: orderForwardStepFormValidationGroup,
    useSubmitBehavior: true,
};
propsStore.insert(orderStepsForwardAddPayloadButtonOptions);

export const orderStepsForwardShowExternalLocationsCheckBoxId =
    'OrderForwardStepForm.showExternalLocationsCheckBox';
const orderStepsForwardShowExternalLocationsCheckBoxOptions: iCheckBoxDisplayOptions = {
    id: orderStepsForwardShowExternalLocationsCheckBoxId,
    text: 't~OrderForwardStepForm:showExternalLocations',
};
propsStore.insert(orderStepsForwardShowExternalLocationsCheckBoxOptions);
